/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import { Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { Editor, EditorState, getDefaultKeyBinding, RichUtils, convertToRaw, convertFromRaw, createWithContent, CompositeDecorator,  } from 'draft-js';
import 'draft-js/dist/Draft.css';

class RichTextEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editorState: EditorState.createEmpty(),
      showURLInput: false,
      urlValue: '',
      urlType: '',
      classMap: {
        LINK: 'draft-link',
        BTN: 'btn btn-theme-button d-md-inline-block d-block',
      },
      styleMap: {
        LINK: {
          cursor: 'pointer',
        },
        BTN: {
          color: 'white',
          cursor: 'pointer',
        },
        CODE: {
          backgroundColor: 'rgba(0, 0, 0, 0.05)',
          fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
          fontSize: 16,
          padding: 2,
        },
      },
    };

    this.focus = () => this.refs.editor.focus();

    this.onChange = this._onChange.bind(this);
    this.handleKeyCommand = this._handleKeyCommand.bind(this);
    this.mapKeyToEditorCommand = this._mapKeyToEditorCommand.bind(this);
    this.toggleBlockType = this._toggleBlockType.bind(this);
    this.toggleInlineStyle = this._toggleInlineStyle.bind(this);

    this.promptForLink = this._promptForLink.bind(this);
    this.onURLChange = (e) => this.setState({urlValue: e.target.value});
    this.confirmUrl = this._confirmUrl.bind(this);
    this.onLinkInputKeyDown = this._onLinkInputKeyDown.bind(this);
  }

  componentDidMount() {
    const { category, values } = this.props;
    const { styleMap } = this.state;

    // Visually identify buttons on our editor, and on the site itself
    // We need to map our entity styling on the frontend using customEntityTransform
    // -- https://github.com/jpuri/draftjs-to-html

    // Set our styles based on manage-frontend configuration on load
    styleMap.BTN.backgroundColor = values.colorStyles.buttonColor;
    styleMap.LINK.color = values.colorStyles.linkColor;
    this.setState({ styleMap });

    const decorator = new CompositeDecorator([{
      strategy: findEntities,
      component: Link,
    }]);
    this.setState({
      editorState: EditorState.createWithContent(convertFromRaw(JSON.parse(values[category].body)), decorator),
    });
  }

  // draft-js helper functions
  _onChange(editorState) {
    const { dispatch, category, categoryType } = this.props;
    this.setState({ editorState });

    dispatch({
      type: 'EDIT_SITE_THEME',
      id: 'body',
      category,
      categoryType,
      value: JSON.stringify(convertToRaw(editorState.getCurrentContent())),
    });
  }

  _handleKeyCommand(command, editorState) {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.onChange(newState);
      return true;
    }
    return false;
  }

  _mapKeyToEditorCommand(e) {
    if (e.keyCode === 9 /* TAB */) {
      const newEditorState = RichUtils.onTab(
        e,
        this.state.editorState,
        4, /* maxDepth */
      );
      if (newEditorState !== this.state.editorState) {
        this.onChange(newEditorState);
      }
      return;
    }
    return getDefaultKeyBinding(e);
  }

  _toggleBlockType(blockType) {
    this.onChange(
      RichUtils.toggleBlockType(
        this.state.editorState,
        blockType
      )
    );
  }

  _toggleInlineStyle(inlineStyle) {
    this.onChange(
      RichUtils.toggleInlineStyle(
        this.state.editorState,
        inlineStyle
      )
    );
  }

  // Helper functions pulled from:
  // https://github.com/facebook/draft-js/blob/main/examples/draft-0-10-0/link/link.html
  _promptForLink(e, type) {
    e.preventDefault();
    const { editorState } = this.state;
    const selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
      const contentState = editorState.getCurrentContent();
      const startKey = editorState.getSelection().getStartKey();
      const startOffset = editorState.getSelection().getStartOffset();
      const blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
      const linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);

      // store the link's inner text in the Entity object so we can access it
      // on the formulary site for google analytics tracking purposes
      const start = selection.getStartOffset();
      const end = selection.getEndOffset();
      const innerText = blockWithLinkAtBeginning.getText().slice(start, end);
      console.log('innerText: ', innerText);

      let url = '';
      if (linkKey) {
        const linkInstance = contentState.getEntity(linkKey);
        url = linkInstance.getData().url;
      }

      this.setState({
        showURLInput: true,
        urlValue: url,
        urlType: type,
        innerText,
      }, () => {
        setTimeout(() => this.refs.url.focus(), 0);
      });
    } else {
      alert('Please select text.');
    }
  }

  // Receives types BTN and LINK
  _confirmUrl(e, type) {
    e.preventDefault();
    const {editorState, urlValue, styleMap, classMap, innerText} = this.state;
    const contentState = editorState.getCurrentContent();

    // https://draftjs.org/docs/api-reference-entity/
    const contentStateWithEntity = contentState.createEntity(
      'LINK', // Both BTN and LINK are LINK types, we style them with class/style
      'MUTABLE',
      {
        url: urlValue,
        // Store the entity's custom styling for our Decorator here,
        // however we cannot pass in a color style attribute for some reason
        style: styleMap[type],
        className: classMap[type],
        type,
        innerText,
      }
    );

    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });

    // toggleLink results in entity w/ type 'LINK', which we style visually on this page with our decorator (onMount),
    const newLinkState = RichUtils.toggleLink(
      newEditorState,
      newEditorState.getSelection(),
      entityKey
    );

    this.setState({
      editorState: newLinkState,
      showURLInput: false,
      urlValue: '',
      urlType: '',
    }, () => {
      setTimeout(() => this.refs.editor.focus(), 0);
    });
  }

  _onLinkInputKeyDown(e) {
    const { urlType } = this.state;
    if (e.which === 13) {
      this._confirmUrl(e, urlType);
    }
  }

  render() {
    const { editorState, urlType, classMap, styleMap } = this.state;
    const { values } = this.props;

    // If the user changes block type before entering any text, we can
    // either style the placeholder or hide it. Let's just hide it now.
    let className = 'RichEditor-editor';
    var contentState = editorState.getCurrentContent();
    if (!contentState.hasText()) {
      if (contentState.getBlockMap().first().getType() !== 'unstyled') {
        className += ' RichEditor-hidePlaceholder';
      }
    }

    let urlInput;
    if (this.state.showURLInput) {
      urlInput =
        <div className="d-flex" style={{ whiteSpace: 'nowrap', fontFamily: 'system-ui' }}>
          <input
            className="border form-control w-50"
            onChange={this.onURLChange}
            ref="url"
            type="text"
            value={this.state.urlValue}
            onKeyDown={this.onLinkInputKeyDown}
          />
          <button
            className="btn btn-primary me-3 text-white ms-4 me-4"
            onClick={(e) => this.confirmUrl(e, urlType)}
          >
            Create {urlType === 'BTN' ? 'Button' : 'Link'}
          </button>
          <button
            className="btn btn-outline-dark"
            onClick={() => {
              this.setState({ showURLInput: false });
            }}
          >
            <FontAwesomeIcon icon={faTimes} size="lg" className="me-2" />
            Cancel
          </button>
        </div>;
    }

    return (
      <>
        <Label className="font-weight-bold">Body Text:</Label>
        <div className="RichEditor-root mb-3">
          {/* Top row of editing, some block-level, some entity-level */}
          <div className="d-flex RichEditor-controls">
            <BlockStyleControls editorState={editorState} onToggle={this.toggleBlockType} />
            <span className="RichEditor-styleButton" onClick={(e) => this.promptForLink(e, 'BTN')}>
              Button
            </span>
            <span className="RichEditor-styleButton" onClick={(e) => this.promptForLink(e, 'LINK')}>
              Link
            </span>
          </div>
          <InlineStyleControls editorState={editorState} onToggle={this.toggleInlineStyle} />
          {urlInput}
          <div className={className} onClick={this.focus}>
            <Editor
              blockStyleFn={getBlockStyle}
              customStyleMap={styleMap}
              editorState={editorState}
              handleKeyCommand={this.handleKeyCommand}
              keyBindingFn={this.mapKeyToEditorCommand}
              onChange={this.onChange}
              ref="editor"
              spellCheck={true}
            />
          </div>
        </div>
      </>
    );
  }
}

// Finds our LINK entities here for styling in CompositeDecorator (onMount)
function findEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(
    (character) => {
      const entityKey = character.getEntity();
      return (
        entityKey !== null &&
        contentState.getEntity(entityKey).getType() === 'LINK'
      );
    },
    callback
  );
}

// Functionally a js-draft LINK entity
const Link = (props) => {
  const { url, style, className, type } = props.contentState.getEntity(props.entityKey).getData();
  return (
    <a
      {...props}
      href={url}
      style={style}
      className={className}
    >
      {props.children}
    </a>
  );
};

const getBlockStyle = (block) => {
  switch (block.getType()) {
    case 'blockquote': return 'RichEditor-blockquote';
    default: return null;
  }
};

class StyleButton extends React.Component {
  constructor() {
    super();
    this.onToggle = (e) => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }

  render() {
    let className = 'RichEditor-styleButton';
    if (this.props.active) {
      className += ' RichEditor-activeButton';
    }

    return (
      <span className={className} onMouseDown={this.onToggle}>
        {this.props.label}
      </span>
    );
  }
}

const BLOCK_TYPES = [
  {label: 'H1', style: 'header-one'},
  {label: 'H2', style: 'header-two'},
  {label: 'H3', style: 'header-three'},
  {label: 'H4', style: 'header-four'},
  {label: 'H5', style: 'header-five'},
  {label: 'H6', style: 'header-six'},
  {label: 'Bulleted List', style: 'unordered-list-item'},
  {label: 'Numbered List', style: 'ordered-list-item'},
];

const BlockStyleControls = (props) => {
  const {editorState} = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className="RichEditor-controls">
      {BLOCK_TYPES.map((type) =>
        <StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      )}
    </div>
  );
};

var INLINE_STYLES = [
  {label: 'Bold', style: 'BOLD'},
  {label: 'Italic', style: 'ITALIC'},
];

const InlineStyleControls = (props) => {
  const currentStyle = props.editorState.getCurrentInlineStyle();

  return (
    <div className="RichEditor-controls">
      {INLINE_STYLES.map((type) =>
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      )}
    </div>
  );
};

const mapStateToProps = (store) => ({
  values: store.sites.values,
});

export default connect(mapStateToProps)(RichTextEditor);
